import api from '../../plugins/api';

// GET /api/crm/vin-blacklist/cars — машины, которые уже есть в базе с VIN из чёрного списка (остаток, сделки).
const getVinBlacklistCars = (params) => {
  return api.get('/api/crm/vin-blacklist/cars', params);
};

export default getVinBlacklistCars;
